import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import carRefundPolicy from '../../../assets/images/cancellation-policy.jpg'
import InnerBanner from '../../molecules/InnerBanner/InnerBanner'

const CarUpgradePolicy = () => {
    return (
        <>

            <InnerBanner
                title="Car Upgrade Policy"
                // subtitle="The Europcar Story"
                imageSrc={carRefundPolicy}
                imageAlt="CarUpgradePolicy"
            />
            <section className="policy-section section-padding">
                <Container>
                    <Row className='policy-section--row'>
                        <Col className="col-12 col">
                            <div className="mb-4">
                                <h3 className="h3 text-uppercase">Introduction</h3>
                                <p style={{ textAlign: 'justify' }}>
                                    At Europcar India, we strive to deliver the exact vehicle model you selected during the booking process. However, due to unforeseen circumstances such as maintenance, high demand, or fleet availability, your originally booked vehicle may occasionally be unavailable. In such cases, the following policies will apply:                                </p>

                            </div>
                            <div className="mb-4">
                                <h3 className="h3 text-uppercase">1. Complimentary Car Upgrade</h3>
                                <p style={{ textAlign: 'justify' }}>
                                    If the selected car model is unavailable, Europcar India will make every effort to provide a similar or upgraded car model at no additional cost to the user. This ensures that you continue to enjoy a comfortable and high-quality rental experience, even if your preferred vehicle is not in stock.                                </p>

                            </div>
                            <div className="mb-4">
                                <h3 className="h3 text-uppercase">2. Downgrade & Refund</h3>
                                <p style={{ textAlign: 'justify' }}>
                                    In the rare instance that neither the selected model nor an equivalent upgrade is available, and a lower-segment car is allotted:
                                </p>
                                <ul style={{ listStyle: 'disc', textAlign: 'justify' }}>
                                    <li>The difference in the base rental cost will be reimbursed to the user.</li>
                                    <li>The refund will be processed in accordance with Europcar India’s Refund Policy.</li>
                                </ul>
                                <p>We are committed to fair treatment and value for money, and this downgrade compensation is part of our effort to ensure customer satisfaction at all times.</p>
                            </div>


                            <div className='mb-4'>
                                <h3 className="h3 text-uppercase">Need Help?</h3>
                                <p>If you have any questions or face any issues related to car upgrades, refunds, or your rental experience, our team is here to assist you.</p>
                                <ul style={{ listStyle: 'disc', textAlign: 'justify' }}>
                                    <li><a href="tel:+918421555659">+91 8421555659 </a></li>
                                    <li><a href="mailto:car.reservations@europcar.in">car.reservations@europcar.in</a></li>
                                </ul>
                                <p>Our customer support team will be happy to guide you through the process and resolve any concerns promptly.
                                </p>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>


        </>
    )
}

export default CarUpgradePolicy;
